var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-page',{attrs:{"title":"Kaluston muokkaus","prev":true,"fallback":{ name: 'Kalusto', query: { tab: 'kalusto' } }}},[_c('v-row',{staticClass:"fill-height"},[_c('v-col',{attrs:{"cols":"12","lg":"12","xl":"10","offset-xl":"1"}},[_c('kalusto-edit',{ref:"kalustoEdit"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }